<template>
  <div>
    <div class="row">
      <div class="col-10">

        <form @submit.prevent="promiseUpdateIntegration = updateIntegration()">
          <div class="container-fluid">

            <field class="mb-3" v-if="!editMode">
              <div slot="label">Integration Name:</div>
              <div slot="value">{{integration.name}}</div>
            </field>
            <form-input v-else
                        label="Integration Name"
                        :value="form.name"
                        :error="errors.name"
                        @form-input="form.name = $event"></form-input>

            <field class="mb-3">
              <div slot="label">{{integration.channels && integration.channels.length > 1 ? 'Channels' : 'Channel'}}:</div>
              <div slot="value" class="comma-separated-list">
                <span v-for="channel in integration.channels" :key="channel.id">
                  <router-link v-if="channel.id"
                               :to="{ name: 'administration.channel-detail.info', params: {id: channel.id}}">
                    {{channel.name}}
                  </router-link>
                </span>
              </div>
            </field>

            <!-- platform specific fields -->
            <component v-if="integrationInfoComponent"
                       :is="integrationInfoComponent"
                       :edit-mode="editMode"
                       :errors="errors"></component>

            <div v-if="errors._general" class="row">
              <div class="alert alert-danger col-12">
                {{ errors._general }}
              </div>
            </div>

            <div v-if="editMode" class="row mb-3">
              <div class="col-12">
                <button class="btn btn-success"
                        v-busy-button="promiseUpdateIntegration">
                  Save
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="col-2">
        <toggle-edit-btn class="d-flex justify-content-end"
                         :editMode="editMode"
                         @click="toggleEditMode"></toggle-edit-btn>
      </div>
    </div>
  </div>
</template>

<script>
  import ToggleEditBtn from '@/components/administration/common/ToggleEditButton'
  import Field from '@/components/administration/common/Field'
  import eventBus from '@/services/event-bus/event-bus'
  import integrationService from '@/services/amio-api/integration.service'
  import FormInput from '@/components/administration/common/form/FormInput'
  import BotanalyticsInfo from '@/components/administration/integration/detail/specific/botanalytics/BotanalyticsInfo'
  import WitAiInfo from '@/components/administration/integration/detail/specific/witai/WitAiInfo'
  import WatsonInfo from '@/components/administration/integration/detail/specific/watson/WatsonInfo'
  import merge from 'ramda/src/merge'
  import formValidatorMixin from '@/mixins/form-validator.mixin'

  export default {
    mixins: [formValidatorMixin],

    components: {
      'field': Field,
      'form-input': FormInput,
      'botanalytics-info': BotanalyticsInfo,
      'wit-ai-info': WitAiInfo,
      'watson-info': WatsonInfo,
      'toggle-edit-btn': ToggleEditBtn
    },

    store: {
      integration: 'administration.integrationDetail.integration',
      form: 'administration.integrationDetail.integrationEdit.editableData'
    },

    data() {
      return {
        editMode: false,
        errors: {
          access_token: false,
          name: false
        },
        promiseUpdateIntegration: null,
        showIntegrationNameInvalidMessage: false
      }
    },

    computed: {

      integrationInfoComponent() {
        if (this.integration.type === 'botanalytics') return 'botanalytics-info'
        if (this.integration.type === 'wit_ai_nlp') return 'wit-ai-info'
        if (this.integration.type === 'watson_nlp') return 'watson-info'

        return null
      }
    },

    methods: {
      updateIntegration() {
        this.formValidator_clearErrors()

        const integrationData = merge({
          name: this.form.name,
          access_token: this.form.access_token
        }, this.form)
        return integrationService
          .patch(this.integration.id, integrationData, [422])
          .then(response => {
            eventBus.$emit('update-integration', response.data)
            this.toggleEditMode()
          })
          .catch((err) => {
            if (err.response.status !== 422) return

            this.formValidator_displayError(err)
          })
          .then(this.clearUpdateIntegrationPromise)
      },

      clearUpdateIntegrationPromise() {
        this.promiseUpdateIntegration = null
      },

      toggleEditMode() {
        this.form.name = this.integration.name

        this.editMode = !this.editMode
        this.formValidator_clearErrors()
        this.showIntegrationNameInvalidMessage = false
      }
    }
  }
</script>
